<template>
  <input-base
    :input="input"
    :review-mode="reviewMode"
    :error="error"
    class="form-wrapper-select"
  >
    <div
      v-if="!input.attributes.locked && !reviewMode"
      class="flex-1 mt-1"
    >
      <select
        :id="input.key"
        ref="input"
        class="w-full appearance-none"
        :name="input.key"
        :value="applicationValue"
        :readonly="input.attributes.locked"
        :required="input.attributes.required"
        @change="updateInput(parentField, input.key, $event.target.value)"
      >
        <slot>
          <option
            :disabled="input.attributes.required"
            :value="null"
          >
            Please Select...
          </option>
          <option
            v-for="(option, index) in options"
            :key="index"
            :value="option"
          >
            {{ option }}
          </option>
        </slot>
      </select>
    </div>
    <span
      v-else
      class="flex-1"
    >
      {{ applicationValue }}
    </span>
  </input-base>
</template>

<script>
import { inputHelperMixin } from "../../mixins/inputHelper";
import { store } from "../../store/application";
export default {
  name: "InputSelect",
  mixins: [inputHelperMixin],
  computed: {
    options() {
      if (this.input.attributes.options && !Array.isArray(this.input.attributes.options)) {
        const partners = store.application["project_partners"].reduce(
          (arr, partner) => {
            if (partner["company"] === null) return arr;
            if (partner["company"].hasOwnProperty("company_details")) {
              arr.push(
                this.$options.filters.sentencecase(
                  partner["company"]["company_details"]["name"]
                )
              );
            }
            return arr;
          },
          []
        );
        return [
          this.$options.filters.sentencecase(
            store.application["lead_applicant"]["company"]["company_details"][
              "name"
            ]
          ),
          ...partners
        ];
      }
      return this.input.attributes.options;
    }
  }
};
</script>

<style>
.form-wrapper-select select {
  @apply pr-6 bg-no-repeat cursor-pointer;
  background-position: center right;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24" height="24px" width="24px" ><g><path fill="currentColor" fill-rule="evenodd" d="M15.3 10.3a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z" /></g></svg>');
}

.form-wrapper-select:hover .form-wrapper:not(.is-locked) {
  @apply border-primary-400;
}
</style>
